import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Clock, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";
import { COMING_SOON } from "../config/comingSoon";

/**
 * What a locked feature's URL renders.
 *
 * The nav entry is already non-tappable, so nobody reaches this by
 * clicking. It exists for the ways people arrive at a URL anyway — a
 * bookmark, a shared link, browser history, someone typing it. Sending
 * those to a 404 would read as "we broke it" rather than "it isn't ready
 * yet", and sending them to the real page would defeat the lock.
 */
export default function ComingSoonPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const meta = COMING_SOON[location.pathname] || {};

  return (
    <div
      className="flex flex-col items-center justify-center text-center px-6 py-20 min-h-[60vh]"
      data-testid="coming-soon-page"
    >
      <div className="w-14 h-14 rounded-2xl bg-violet-500/10 flex items-center justify-center mb-5">
        <Clock className="w-7 h-7 text-violet-500" />
      </div>

      <h1 className="text-2xl font-bold mb-2">
        {meta.label || "This feature"} is coming soon
      </h1>

      {meta.blurb && (
        <p className="text-sm text-muted-foreground max-w-md mb-1">{meta.blurb}</p>
      )}
      <p className="text-sm text-muted-foreground max-w-md mb-7">
        It isn&apos;t ready yet. Nothing you need to do — it will appear here
        when it is.
      </p>

      <Button variant="outline" onClick={() => navigate("/dashboard")}
              data-testid="coming-soon-back">
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to dashboard
      </Button>
    </div>
  );
}
